module.exports = __webpack_public_path__ + "static/media/accessory__servo.4d43e75d.jpg";